<template>

    <AjanlatBase :titleExtra="titleExtra"
                 v-if="nyugdijasVisible()
                    || polgarorVisible()
                    || szerzAzonVisible()
                    || biztSzamVisible()
                    || coopVisible()
                    || szakszervVisible()">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="nyugdijasVisible()" :attributes="nyugdijas_torzsszam"/>

                <BnFormField v-if="polgarorVisible()" :attributes="kobe_polgaror_igazsz"/>

                <BnFormField v-if="szerzAzonVisible()" :attributes="signal_szerz_azon"/>

                <BnFormField v-if="biztSzamVisible()" :attributes="signal_bbizt_szam"/>

                <BnFormField v-if="coopVisible()" :attributes="signal_coop_kartyaszam"/>

                <BnFormField v-if="szakszervVisible()" :attributes="signal_szakszervezetnev"/>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    name: 'AjanlatAdatokB4_V0',
    components: { BnFormField, AjanlatBase },
    mixins: [offerData],
    version: 'v0',
    methods: {
        nyugdijasVisible() {
            return this.$store.getters.tarifaData.ajanl_nyugdijas === true;
        },
        polgarorVisible() {
            return this.$store.getters.tarifaData.polgaror === true;
        },
        szerzAzonVisible() {
            return this.kedvezmenyek.partner === true
                || (this.kedvezmenyek.egyuttcasco === true && !this.egyuttkotve);
        },
        biztSzamVisible() {
            return this.kedvezmenyek.szakszervezet === true;
        },
        coopVisible() {
            return this.kedvezmenyek.coop === true;
        },
        szakszervVisible() {
            return this.kedvezmenyek.szakszervezet === true;
        },
    },
    data() {
        return {
            nyugdijas_torzsszam: {
                type: 'text',
                label: 'Nyugdíjas törzsszám',
                visible: true,
                editable: true,
                mezo: 'nyugdijas_torzsszam',
                path: 'tarifaData.nyugdijas_torzsszam',
                help: true,
            },
            kobe_polgaror_igazsz: {
                type: 'text',
                label: 'Polgárőr tagsági/igazolvány szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'kobe_polgaror_igazsz',
                path: 'tarifaData.kobe_polgaror_igazsz',
            },
            signal_szerz_azon: {
                type: 'text',
                label: 'Signal szerződés szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'signal_szerz_azon',
                path: 'tarifaData.signal_szerz_azon',
            },
            signal_szakszervezetnev: {
                type: 'text',
                label: 'Szakszervezet neve',
                visible: true,
                editable: true,
                help: true,
                mezo: 'signal_szakszervezetnev',
                path: 'tarifaData.signal_szakszervezetnev',
            },
            signal_bbizt_szam: {
                type: 'text',
                label: 'Szakszervezeti balesetbiztosítás szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'signal_bbizt_szam',
                path: 'tarifaData.signal_bbizt_szam',
            },
            signal_coop_kartyaszam: {
                type: 'text',
                label: 'Coop kártya szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'signal_coop_kartyaszam',
                path: 'tarifaData.signal_coop_kartyaszam',
            },
        };
    },
};
</script>
